
<h1 class="h3 mb-3 fw-normal">Glömt lösenord</h1>
<app-text-input [label]="'Email'" [model]="email" (model)="email = $event"></app-text-input>
<div *ngIf="requested">Du har fått ett email med instruktioner på hur du återställer ditt lösenord</div>
<button mat-raised-button color="primary" (click)="reset()">Återställ</button>
